<template>
	<!-- ComingSoon -->
	<div v-if="priceStatus === 'ComingSoon'">
		<p class="caption-small">Coming Soon</p>
	</div>

	<!-- CannotOrderOnline -->
	<div v-else-if="priceStatus === 'CannotOrderOnline'">
		<div class="caption-2" v-if="prices && prices.value">
			<p data-cy="product-price">
				<span 
					:style="{fontSize: '20px'}"
					v-html="getLocalizedPriceStr(prices.value, prices.currencyIsoCode)"
				></span>
			</p>
		</div>
	</div>

	<!-- Login -->
	<div v-else-if="priceStatus === 'Login'">
		<div v-if="!getLoggedInStatus">
			<p class="caption mobile-caption-small">
				<a href="#" @click.prevent="$emit('logInRequested')">Log in</a>
				to see your account pricing
			</p>
		</div>
		<div class="price-style with-price with-price" v-else-if="getLoggedInStatus && prices && prices.value">
			<div class="price-style-align">
				<p class="caption-2 custom-price mobile-headline-6" v-if="isDiscounted" data-cy="custom-price h6">
					<span v-html="getLocalizedPriceStr(customerPrice.amount, customerPrice.currencyIsoCode)"></span>
				</p>
				<p class="caption-2 mobile-headline-6">
					<span v-if="isDiscounted" data-cy="product-discount">
						{{ prices.value | getPercentDiff(customerPrice.amount) }}% off
					</span>
					<span 
						:class="{'strike-through': isDiscounted}"
						:style="{fontSize: isDiscounted ? '16px' : '20px'}"
						v-html="getLocalizedPriceStr(conditionalPrice, conditionalCurrencyIsoCode)"
						data-cy="product-price-before-discount"
					>
					</span>
				</p>
			</div>
			<web-component 
				_selector="wca-add-to-cart" 
				cart-endpoint="/product-fragments-api/cart"
				button-style="mat-raised-button"
				:products="JSON.stringify([{CatalogNumber: product.catalogNumber.toString(), Quantity:1}])"
			></web-component>
		</div>
	</div>

	<!-- Display -->
	<div v-else-if="priceStatus === 'Display' && prices && prices.value" class="price-style with-price">
		<div class="price-style-align">
			<p class="custom-price h6" v-if="isDiscounted" data-cy="product-price">
				<span v-html="getLocalizedPriceStr(customerPrice.amount, customerPrice.currencyIsoCode)"></span>
			</p>
			<p class="caption-2 mobile-headline-6">
				<span v-if="isDiscounted" data-cy="product-discount"
					>{{ prices.value | getPercentDiff(customerPrice.amount) }}% off
				</span>
				<span 
					:class="{'strike-through': isDiscounted}" 
					:style="{fontSize: isDiscounted ? '16px' : '20px'}"
					v-html="getLocalizedPriceStr(conditionalPrice, conditionalCurrencyIsoCode)"
					data-cy="product-price-before-discount"
				>
				</span>
			</p>
		</div>
		<web-component 
			_selector="wca-add-to-cart" 
			cart-endpoint="/product-fragments-api/cart"
			button-style="mat-raised-button"
			:products="JSON.stringify([{CatalogNumber: product.catalogNumber.toString(),Quantity:1}])"
		></web-component>
	</div>
</template>
<script>
import {mapGetters} from 'vuex';
import priceFormatter from '@/mixins/priceFormatter';

export default {
	name: 'PriceStatus',
	mixins: [priceFormatter],
	props: {
		country: {
			type: String,
		},
		product: {
			type: Object,
		},
		prices: {
			type: [Object, Boolean],
		},
		priceStatus: {
			type: String,
		},
	},
	data() {
		return {
			customerPrice: null,
		};
	},
	methods: {
		getLocalizedPriceStr(price, currency) {
			return "<span translate='no'>" + this.formatPrice(price, currency) + '</span>';
		},
	},
	computed: {
		findCustomerPrice() {
			return this.$store.getters['customerPrices/priceFor'](this.product.catalogNumber);
		},
		...mapGetters(['getLoggedInStatus']),
		conditionalPrice() {
			return this.isDiscounted ? this.prices.value : this.customerPrice ? this.customerPrice.amount : this.prices.value;
		},
		conditionalCurrencyIsoCode() {
			return this.isDiscounted ? this.prices.currencyIsoCode : this.customerPrice ? this.customerPrice.currencyIsoCode : this.prices.currencyIsoCode;
		},
		isDiscounted() {
			return this.customerPrice ? this.customerPrice.amount < this.prices.value : false;
		},
	},
	watch: {
		findCustomerPrice: {
			handler(newValue) {
				this.customerPrice = newValue;
			},
			immediate: true,
		},
	},
};
</script>
<style lang="scss">
wca-add-to-cart .mat-raised-button.ng-star-inserted {
	@media (min-width: $mobile + 1) {
		margin-bottom: 8px;
	}
	@media (max-width: $mobile) {
		margin-bottom: 12px;
		width: 100%;
		max-width: 296px;
	}
}

body wca-add-to-cart {
	.mat-button,
	.mat-flat-button,
	.mat-raised-button,
	.mat-stroked-button {
		height: 32px;
		line-height: 32px;
	}
}

wca-add-to-cart button.mat-raised-button.mat-button-disabled.mat-button-disabled {
		background-color: rgba(0,0,0,.12);
}

.price-style-align {
	@media (max-width: $mobile) {
		padding: 0 16px;
	}
}
</style>
